/** Shared button classes, derived from the site theme. One place so the sections cannot drift. */

export const CTA_PRIMARY =
  'inline-flex items-center justify-center gap-2 rounded-lg bg-orange-500 px-6 py-3 text-xs font-bold uppercase tracking-wider text-white shadow-lg transition-all duration-200 hover:scale-105 hover:bg-orange-600 hover:shadow-xl md:px-8 md:py-4 md:text-sm'

export const CTA_SECONDARY =
  'inline-flex items-center justify-center gap-2 rounded-full border border-gray-200 bg-white px-6 py-3 text-xs font-bold uppercase tracking-wider text-gray-700 transition-colors hover:border-theme-orange hover:text-theme-orange'

export const CARD = 'rounded-xl border border-gray-100 bg-white shadow-sm'

export const SECTION_NUMBER =
  'mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-theme text-xs font-bold text-white'
